import React from "react"

function Loading() {
  return (
    <div className="loading">
      <span className="loader" />
      <br /> <br />
      <p> Loading... </p>
    </div>
  )
}

export default Loading
